import { render, staticRenderFns } from "./englishPush.vue?vue&type=template&id=98a8d226&scoped=true"
import script from "./englishPush.vue?vue&type=script&lang=js"
export * from "./englishPush.vue?vue&type=script&lang=js"
import style0 from "./englishPush.vue?vue&type=style&index=0&id=98a8d226&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a8d226",
  null
  
)

export default component.exports